import { render, staticRenderFns } from "./FormularioRevision.vue?vue&type=template&id=6905d2b3"
import script from "./FormularioRevision.vue?vue&type=script&lang=js"
export * from "./FormularioRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports